export default {
  // default view component
  inject: {},
  components: {},
  directives: {},
  computed: {},
  methods: {},
  props: [],
}
